module.exports = __webpack_public_path__ + "static/media/ic-block.966f1ec3.svg";